import { render, staticRenderFns } from "./ExpanderComponent.vue?vue&type=template&id=4a0d8cfb&scoped=true&"
import script from "./ExpanderComponent.vue?vue&type=script&lang=js&"
export * from "./ExpanderComponent.vue?vue&type=script&lang=js&"
import style0 from "./ExpanderComponent.vue?vue&type=style&index=0&id=4a0d8cfb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0d8cfb",
  null
  
)

export default component.exports